<template>
   <div class="animated fadeIn">
      <b-breadcrumb>
         <h4>Color Finder</h4>
      </b-breadcrumb>



      <b-col md="12" style="margin-top:10px;">
         <b-col md="12">
          <!-- <v-card> -->
            <b-row class="mt-2 mb-2"> 

              <b-col md="4">
                   <b-form-group >
                   <label for="name">Select Panton Type</label>
                    <b-form-input list="panton-list-id" v-model="colortype.panton_type" ></b-form-input>

                    <datalist id="panton-list-id" >
                      <option>Select Panton Type</option>
                      <option value="TCX">TCX</option>
                      <option value="TPX">TPX</option>
                    </datalist>
                    
                  </b-form-group>
                </b-col>         
      
              <b-col md="4">
                   <b-form-group >
                   <label for="name">Select Color Family</label>
                    <b-form-input list="family-list-id" v-model="customer.color_family" v-on:change="getselectedfamilycolor(customer.color_family);  "></b-form-input>

                    <datalist id="family-list-id" >
                      <option>Select Color Family</option>
                      <option v-for="customer in color_family">{{ customer.color_family }}</option>
                    </datalist>
     
                  </b-form-group>
                </b-col>
                 

                <b-col md="4">
                 <b-form-group >
                 <label for="name">Select Panton Color</label>
                  <input placeholder="Select an Option" class="form-control" @input="setSelectedcolor" list="list"/>
                  <datalist id="list">
                    <option v-for="colorcode in color_name" :value="colorcode.pantone_no">{{colorcode.color_name}}</option>
                  </datalist>
                  
                 </b-form-group> 

                </b-col>


                
                <b-col md="12">
                  <div id="showcolor" style="padding:20px;font-size:20px;height: 70px; border-width: 2px; border-color: black; text-align: center; border: 1px solid black; border-radius: 4px;"></div>
                </b-col>
                
              </b-row> 

            
          <!-- </v-card> -->
        </b-col>
      </b-col>
   </div>
</template>

<script>
    import CONSTANTS from "@/utils/constants";
    import Utils from "@/utils";
    import Vue from 'vue';
    // import { AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
    // Vue.use(AutoCompletePlugin);
    const axios = require('axios')

    // import App from './App.vue';

  export default {
  //    components: {
  //   Autocomplete,
  // },
    data() {
      return {
      
            result1:[],
            list:[],
            color_family:[],
            customer: {},
            colorcode:{},
            color_name:[],
            selected:'',
            familydata:[],
            colortype: {},
            pantonno_result:[],
            pantoncolor: [],
            showhexcolor:'',
            showcolorname:'',
      };
  },
  created: function() { 
  var userData = localStorage.getItem('userData')
        var userInfo = JSON.parse(userData)
        
   this.getcolorfamilylist();
  },
    methods: { 
      getcolorfamilylist: function(value) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
     
      const Obj ={"color_type":"TCX"}
      axios.post(`${CONSTANTS.API_URL}/getcolorfamilylist`,Obj)
        .then((result) => {
          if (result.data.returnmsg === 'Successful') {
            this.color_family  = result.data.returnvalue;
          }else {
           this.color_family =[];
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      
    },

    getselectedfamilycolor: function(color) {
          const Obj = {
      color_family: color
      }
      axios.post(`${CONSTANTS.API_URL}/getlistagainstcolorfamily`, Obj)
        .then((result) => {
          this.result1 = result.data
          if (this.result1.returnmsg === 'Successful') {
            this.color_name  = this.result1.returnvalue;
          }else {
           this.color_name =[];
          }

          
        })
      
   
            
      
      
    },


    setSelectedcolor: function(e) 
    {

      // var x=document.getElementById('opt').style.backgroundColor=opt.value;
      // .style.backgroundColor=colorData;
      // document.body.style.backgroundColor =  colorData;
      
      // var colorData='12-6204 TCX'


      const Obj = {
      pantone_no: e.target.value
      }

      axios.post(`${CONSTANTS.API_URL}/getlistagainstpantonno`, Obj)
        .then((result) => {
          this.pantonno_result = result.data
          if (this.pantonno_result.returnmsg === 'Successful') {
            this.pantoncolor  = this.pantonno_result.returnvalue;
            this.showhexcolor=this.pantoncolor[0].hex_code;
            this.showcolorname=this.pantoncolor[0].color_name;

            document.getElementById("showcolor").style.backgroundColor =this.showhexcolor;
             document.getElementById("showcolor").innerHTML=this.showcolorname+ " - " +this.showhexcolor;

          }else {
           this.pantoncolor =[];
          }


          
        })
      
   
            

    
      
    },


      }
    
  }
</script>

</style>